const CURRENCY_FORMATER = new Intl.NumberFormat('ru-RU', {
  currency: 'RUB',
  style: 'currency'
});

export function formatCurrency(number: number): string {
  return CURRENCY_FORMATER.format(number);
}
